module.exports = __webpack_public_path__ + "img/icon-truck.9a435118.svg";